/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ParticipantPatchRole = typeof ParticipantPatchRole[keyof typeof ParticipantPatchRole] | null;


export const ParticipantPatchRole = {
  interviewer: 'interviewer',
  candidate: 'candidate',
  client: 'client',
  reference: 'reference',
  other: 'other',
  unknown: 'unknown',
} as const;
